module.exports = __webpack_public_path__ + "media/gundula5.c5722737.mp3";